import { render, staticRenderFns } from "./ProdutoresExibicaoMelhores.vue?vue&type=template&id=6e754637&scoped=true&"
import script from "./ProdutoresExibicaoMelhores.vue?vue&type=script&lang=js&"
export * from "./ProdutoresExibicaoMelhores.vue?vue&type=script&lang=js&"
import style0 from "./ProdutoresExibicaoMelhores.vue?vue&type=style&index=0&id=6e754637&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e754637",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
